import { render, staticRenderFns } from "./right_top.vue?vue&type=template&id=0c8d532a&scoped=true"
import script from "./right_top.vue?vue&type=script&lang=js"
export * from "./right_top.vue?vue&type=script&lang=js"
import style0 from "./right_top.vue?vue&type=style&index=0&id=0c8d532a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d532a",
  null
  
)

export default component.exports